// Mouse wheel events to weapon-switch notches. One physical notch can arrive as one event (a
// plain wheel), as a dozen small ones (trackpad, smooth wheel) or as a burst of full-size ones
// (free-spinning wheel); a gesture must not cycle through the weapons.

/** `deltaY` in pixels from which one event is a notch on its own (plain wheels send 53..120 per notch). */
const NOTCH_EVENT_PX = 30;
/** Smaller events (trackpads, smooth wheels) add up to a notch at this much. */
const NOTCH_PX = 100;
/** Sums from earlier events are forgotten after this idle time. */
const GESTURE_GAP_MS = 250;
/** At most one notch per this time: a spinning wheel switches at a rate the player can follow. */
const MIN_GAP_MS = 60;

/** `WheelEvent.deltaMode` line and page units in pixels. */
const LINE_PX = 40;
const PAGE_PX = 800;

export class WheelNotches {
  private sum = 0;
  private lastEvent = Number.NEGATIVE_INFINITY;
  private lastNotch = Number.NEGATIVE_INFINITY;

  /** `minGapMs`: the least time between two notches (weapon switching: `MIN_GAP_MS`; the jump wheel: none). */
  constructor(private readonly minGapMs = MIN_GAP_MS) {}

  /** Whether this wheel event completes a notch (`nowMs`: the event's timestamp). */
  push(deltaY: number, deltaMode: number, nowMs: number): boolean {
    const px = deltaMode === 1 ? deltaY * LINE_PX : deltaMode === 2 ? deltaY * PAGE_PX : deltaY;
    if (px === 0) return false;
    if (nowMs - this.lastEvent > GESTURE_GAP_MS) this.sum = 0;
    this.lastEvent = nowMs;
    if (Math.abs(px) < NOTCH_EVENT_PX) {
      if (Math.sign(px) !== Math.sign(this.sum)) this.sum = 0;
      this.sum += px;
      if (Math.abs(this.sum) < NOTCH_PX) return false;
    }
    this.sum = 0;
    if (nowMs - this.lastNotch < this.minGapMs) return false;
    this.lastNotch = nowMs;
    return true;
  }
}
